import { css } from '@emotion/react';

import adsResetStyles from './ads-reset.styles';
import baseReset from './base-reset.styles';
import browserFixes from './browser-fixes.styles';

/**
 *
 * __Atlassian Design System (ADS) Theme Reset__
 *
 * This is a lightweight version of `@atlaskit/css-reset` made for WAC.
 * It is recommended to be used in conjuntion with `@atlaskit/theme`
 *
 * @example
 * ```jsx
 * import { resetStyles } from '@atlassiansox/ads-theme-reset';
 *
 * const App = () => (
 *  <div css={[resetStyles, appStyles]}>
 *   <Component />
 *  </div>
 * );
 * ```
 */
export const resetStyles = css`
  ${baseReset}
  ${adsResetStyles}
  ${browserFixes}
`;
